import React, { useState } from 'react';

const sections = [
  {
    title: '제1조 (수집하는 개인정보의 항목 및 수집방법)',
    content: `
1항. 수집하는 개인정보의 항목
회사는 회원가입, 상담, 서비스 신청 등을 위해 아래와 같은 개인정보를 수집하고 있습니다.
가. 수집항목: 이름, 휴대전화번호, 이메일, 서비스 이용기록, 접속 로그, 쿠키, 접속 IP 정보
나. 개인정보 수집방법: 홈페이지(회원가입), 서면양식, 고객센터를 통한 전화와 온라인 상담

2항. 개인정보 수집방법
회사는 다음과 같은 방법으로 개인정보를 수집합니다.
가. 홈페이지, 모바일 앱, 서면 양식, 팩스, 전화, 상담 게시판, 이메일, 이벤트 응모, 배송 요청

3항. 회사는 기본적 인권 침해의 우려가 있는 민감한 개인정보(인종 및 민족, 사상 및 신조, 출신지 및 본적지, 정치적 성향 및 범죄기록 등)는 수집하지 않습니다.
    `,
  },
  {
    title: '제2조 (개인정보의 수집 및 이용목적)',
    content: `
회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.
- 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산
- 콘텐츠 제공, 구매 및 요금 결제, 물품배송 또는 청구지 등 발송
- 회원 관리: 회원제 서비스 이용에 따른 본인확인, 개인 식별, 불량회원의 부정 이용 방지 등
- 마케팅 및 광고에 활용: 이벤트 등 광고성 정보 전달, 접속 빈도 파악 등
    `,
  },
  {
    title: '제3조 (개인정보의 공유 및 제공)',
    content: `
회사는 이용자의 개인정보를 '제2조 개인정보의 수집 및 이용목적'에서 고지한 범위 내에서 사용하며, 이용자의 사전 동의 없이는 본래의 범위를 초과하여 이용하거나 외부에 공개하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.
- 이용자들이 사전에 동의한 경우
- 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우
    `,
  },
  {
    title: '제4조 (개인정보의 보유 및 이용기간)',
    content: `
이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용 목적이 달성되면 지체 없이 파기합니다.
단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다.
가. 회사 내부 방침에 의한 정보보유 사유
- 부정이용기록: 1년
나. 관련 법령에 의한 정보보유 사유
- 계약 또는 청약철회 등에 관한 기록: 5년 (전자상거래 등에서의 소비자보호에 관한 법률)
- 대금결제 및 재화 등의 공급에 관한 기록: 5년
- 소비자의 불만 또는 분쟁처리에 관한 기록: 3년
    `,
  },
  {
    title: '제5조 (개인정보의 파기절차 및 방법)',
    content: `
회사는 원칙적으로 개인정보 수집 및 이용 목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다.
파기절차 및 방법은 다음과 같습니다.

- 파기절차: 회원님이 회원가입 등을 위해 입력하신 정보는 목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도 문서함) 내부 방침 및 기타 관련 법령에 따라 일정 기간 저장된 후 파기됩니다.
- 파기방법: 전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.
    `,
  },
  {
    title: '제6조 (개인정보 제공)',
    content: `
회사는 이용자의 개인정보를 외부에 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.
- 이용자들이 사전에 동의한 경우
- 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우
    `,
  },
  {
    title: '제7조 (이용자 및 법정대리인의 권리와 그 행사방법)',
    content: `
이용자 및 법정 대리인은 언제든지 등록되어 있는 자신 혹은 당해 만 14세 미만 아동의 개인정보를 조회하거나 수정할 수 있으며, 가입해지를 요청할 수도 있습니다.
개인정보의 조회·수정은 '개인정보변경'(또는 '회원정보수정' 등)을 통해, 가입해지(동의 철회)는 '회원탈퇴'를 통해 가능합니다.
    `,
  },
  {
    title: '제8조 (개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항)',
    content: `
회사는 이용자에게 특화된 맞춤서비스를 제공하기 위해 이용자의 정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다.
- 쿠키 설정 거부 방법: 웹 브라우저의 도구 > 인터넷 옵션 > 개인정보 메뉴 설정을 통해 쿠키 저장을 거부할 수 있습니다.
단, 쿠키 저장을 거부할 경우 로그인이 필요한 일부 서비스 이용에 어려움이 있을 수 있습니다.
    `,
  },
  {
    title: '제9조 (개인정보의 기술적/관리적 보호 대책)',
    content: `
회사는 이용자의 개인정보를 안전하게 관리하기 위하여 다음과 같은 기술적/관리적 대책을 강구하고 있습니다.
- 비밀번호 암호화 저장
- 해킹 등에 대비한 보안 프로그램 설치 및 정기적 갱신
- 개인정보에 대한 접근 제한
    `,
  },
  {
    title: '제10조 (개인정보관리책임자)',
    content: `
회사는 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같은 개인정보관리책임자를 지정하고 있습니다.

[개인정보관리책임자]
- 성명: 김OO
- 직책: CTO
- 이메일: privacy@example.com
    `,
  },
  {
    title: '제11조 (고지의 의무)',
    content: `
현 개인정보처리방침은 2017년 10월 1일부터 적용됩니다.
내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일 전부터 홈페이지의 공지사항을 통하여 고지할 것입니다.
    `,
  },
  {
    title: '제12조 (정책 변경에 대한 안내)',
    content: `
개인정보처리방침은 법령·정책 또는 보안기술의 변경에 따라 내용의 추가·삭제 및 수정이 있을 수 있으며, 변경 시에는 시행일자 등을 부여하여 홈페이지를 통해 고지합니다.
    `,
  },
  {
    title: '제13조 (기타)',
    content: `
공고일: 2017년 09월 21일
시행일: 2017년 10월 01일
    `,
  },
];

const PrivacyPolicy = ({ firstSectionRef }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="privacy-container flex-row align-center justify-center">
      <div ref={firstSectionRef} className="grid flex-full py-144">
        <h1 className={'pb-64'}>개인정보처리방침</h1>
        <h3 className={'pb-64'}>
          ㈜디엔에이클라우드(이하 “회사”)은 「정보통신망 이용촉진 및 정보보호
          등에 관한 법률」 등 모든 관련 법규를 준수하며, 회사의 서비스를
          이용하는 고객(이하 “이용자”)의 개인정보가 보호받을 수 있도록 최선을
          다하고 있습니다.
          <br />
          <br />
          회사는 개인정보처리방침의 공개를 통하여 이용자의 개인정보가 어떠한
          목적과 방식으로 이용되고 있으며 개인정보보호를 위해 어떠한 조치가
          취해지고 있는지를 알려 드립니다.
          <br />
          <br />본 개인정보처리방침은 관련 법령의 개정이나 회사 내부방침에 의해
          변경될 수 있으므로 회원 가입 시나 사이트 이용 시에 수시로 확인하여
          주시기 바랍니다.
        </h3>
        <div className="accoList flex-col">
          {sections.map((section, index) => (
            <div className="accordion" key={index}>
              <button
                className="accordion-header flex-row align-center justify-between px-16 py-32"
                onClick={() => toggle(index)}
              >
                <span>{section.title}</span>{' '}
                <span
                  className={`flex-row justify-center align-center iconWrap ${activeIndex === index ? 'open' : ''}`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="8"
                    viewBox="0 0 14 8"
                    fill="none"
                  >
                    <path
                      d="M1.0625 6.86621L7 1.0144L12.9375 6.86621"
                      stroke="#555555"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </button>
              <div
                className={`accordion-content ${activeIndex === index ? 'open' : ''}`}
              >
                <span>{section.content}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
